import { ReactComponent as OrigamiSvg } from "../../assets/origami.svg";
import { ReactComponent as SwordSvg } from "../../assets/sword.svg";
import { TRAINING_MODE_QUEST } from "../../constants/entrainementSetup";
import "./TrainingMenuIcon.css";

export default function TrainingMenuIcon({
  mode = "free",
  size = 50,
  color = "#39210d",
  onClick,
  className,
  style = {},
  ...rest
}) {
  const isQuest = mode === TRAINING_MODE_QUEST;
  const Svg = isQuest ? SwordSvg : OrigamiSvg;

  return (
    <Svg
      width={size}
      height={size}
      onClick={onClick}
      className={[
        "menu-training-icon",
        isQuest ? "menu-training-icon--sword" : "menu-training-icon--origami",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      style={{
        width: size,
        height: size,
        color,
        cursor: onClick ? "pointer" : undefined,
        ...style,
      }}
      aria-hidden="true"
      {...rest}
    />
  );
}
